import { Pipe, PipeTransform } from '@angular/core';
import { LangService } from '../services/lang.service';

@Pipe({
  name: 'translateBeginning'
})
export class TranslateBeginningPipe implements PipeTransform {

  constructor(private lang: LangService) {}

  transform(str: string, idLang: number): string {
    return this.lang.translateBeginning(str, idLang)
  }

}
